import {
  CommonDropdownField,
  type CommonDropdownFieldProps,
} from "../../../../common-ui/form-fields/CommonDropdownField";
import { getFieldProps } from "../../../../common-ui/form-fields/getFieldProps";
import { transformGoodsTypeOption } from "../../../../common/utils/optionTransformers";
import {
  type GoodsTypesQueryRefProps,
  useGoodsTypes,
} from "../../../../services/intermodal/hooks/useGoodsTypes";
import type { UpdateIntermodalBookingGoodFormModel } from "../../../../services/intermodal/updateIntermodalReducer";
import { hasDropdownValueChanged } from "../../../multiple-create/hooks/useDropdownField";
import { useUpdateIntermodalGoodsField } from "../../hooks/useUpdateIntermodalGoodsFields";

export interface GoodsTypeDropdownFieldProps
  extends
    Omit<
      CommonDropdownFieldProps<
        UpdateIntermodalBookingGoodFormModel["goodsType"]
      >,
      | "onValueChange"
      | "value"
      | "trackerAction"
      | "options"
      | "transformOption"
      | "isLoading"
    >,
    GoodsTypesQueryRefProps {
  goodsId: string;
}

export const UpdateGoodsTypeDropdown = ({
  goodsId,
  goodsTypesQueryRef,
  ...props
}: GoodsTypeDropdownFieldProps) => {
  const { goodsTypes } = useGoodsTypes(goodsTypesQueryRef);
  const fieldProps = useUpdateIntermodalGoodsField(goodsId, "goodsType");

  return (
    <CommonDropdownField
      {...props}
      {...getFieldProps(props, fieldProps)}
      transformOption={transformGoodsTypeOption}
      options={goodsTypes.map((g) => transformGoodsTypeOption(g))}
      changed={hasDropdownValueChanged(fieldProps, transformGoodsTypeOption)}
      filterOption={(option) => option.data.data.isValid}
    />
  );
};
